import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { useHistory } from 'react-router-dom';
import classes from './usersTable.module.scss';
import { ReactComponent as Edith } from '../../assets/images/edith.svg';
import { User } from '../../types/user';
import { statusSelectData, roleSelectData } from '../../types/utils/constants';
import { useBlock, useUsers } from '../../hooks/entityHooks';
import { BlockDialog } from '../Dialogs/blockUserDialog';
import { UnblockDialog } from '../Dialogs/unblockUserDialog';
import { EditUserDialog } from '../Dialogs/editUserDialog';

const useStyles = makeStyles({
  root: {
    background: '#FF7221 !important',
    borderRadius: 0,
    width: 160,
    color: '#FFFFFF !important',
    textTransform: 'none',
    fontWeight: 550,
    // color: '#FFFFFF',
    '&:hover, &:focus': {
      background: '#DE6109',
    },
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    height: 38,
    fontSize: 14,
    padding: '0 30px',
  },
  restore: {
    textTransform: 'none',
    background: 'white  !important',
    width: 160,
    height: 38,
    fontSize: 14,
    fontFamily: 'HelveticaNeueCyr',
    color: '#FF7221 !important',
    border: '1px solid #FF7221  !important',
    borderRadius: 0,
    fontWeight: 550,
  },
});

type Props = {
  list: User[];
  handleChange(): void;
};
export const UsersTable = ({ list, handleChange }: Props) => {
  const style = useStyles();
  const [blockId, setBlockId] = useState<number>(0);
  const history = useHistory();
  const [openBlock, setOpenBlock] = useState(false);
  const [openUnblock, setOpenUnblock] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const handleCloseBlock = () => {
    setOpenBlock(!openBlock);
  };

  const handleCloseUnblock = () => {
    setOpenUnblock(!openUnblock);
  };

  const handleCloseEdit = () => {
    setOpenEdit(!openEdit);
  };
  const { blockUser: block, unblockUser: unblock } = useBlock();
  const handleUnblock = (id: number) => {
    const result = unblock(id);
    result.then(() => handleChange());
  };

  const handleBlock = (id: number) => {
    const result = block(id);
    result.then(() => handleChange());
  };

  const goToUserProfile = (id: number) => {
    history.push(`/user/${id}`);
  };
  return (
    <>
      {list.map((li) => {
        const { email, roleName, status, id, name, surname } = li;
        return (
          <tr className={classes.tr} key={id}>
            <td>
              <p className={classes.span}>
                <Edith
                  className={classes.edith}
                  onClick={() => {
                    setBlockId(id);
                    setOpenEdit(true);
                  }}
                />{' '}
                <span onClick={() => goToUserProfile(id)}>{email}</span>
              </p>
            </td>
            <td>
              <p>
                {surname} {name}
              </p>
            </td>
            <td>
              <p>{roleName}</p>
            </td>
            <td>
              <p style={+status === 11 ? { color: '#FF7221' } : {}}>
                {statusSelectData.map(([numeric, text]) =>
                  numeric === status.toString() ? text : null,
                )}
              </p>
            </td>
            <td>
              {status === 1 ? (
                <Button
                  className={style.root}
                  onClick={() => {
                    setBlockId(id);
                    setOpenBlock(true);
                  }}
                >
                  Блокировать
                </Button>
              ) : (
                <Button
                  className={style.restore}
                  onClick={() => {
                    setBlockId(id);
                    setOpenUnblock(true);
                  }}
                >
                  Восстановить
                </Button>
              )}
            </td>
          </tr>
        );
      })}
      <BlockDialog
        id={blockId}
        handleBlock={handleBlock}
        handleClose={handleCloseBlock}
        open={openBlock}
      />

      <UnblockDialog
        id={blockId}
        handleBlock={handleUnblock}
        handleClose={handleCloseUnblock}
        open={openUnblock}
      />
      <EditUserDialog
        id={blockId}
        open={openEdit}
        handleClose={handleCloseEdit}
        handleChange={handleChange}
      />
    </>
  );
};
